import React from 'react';

import {Container} from 'Components/Utilities';

import UnAuthHeader from "Components/Layouts/TopMenu/UnAuthHeader";
import Header from "Components/Layouts/TopMenu/Header";

export default class Unauthenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const {children, title} = this.props;

        return (
            <div className="min-h-screen bg-white">
                <Header pageVideoHeader={ "bupa-banner.mp4" } />

                <Container>
                    { children }
                </Container>
            </div>
        )
    };
}
